import script from "./ViewFileWapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewFileWapper.vue?vue&type=script&setup=true&lang=js"

import "./ViewFileWapper.vue?vue&type=style&index=0&id=f74a8448&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f74a8448"]])

export default __exports__